module.exports = __webpack_public_path__ + "img/g3.46832a35.jpg";